





// import React, { useState, useEffect } from "react";
// import { BsEye } from "react-icons/bs";
// import { CgMoreVertical } from "react-icons/cg";
// import { useNavigate } from "react-router-dom";
// import { APPLICATION_API } from "../../resources/resource";
// import { useFetchData } from "../../hooks/useFtechData";

// import Loader from "../../component/utilities/Loader";
// import { Dialog } from "../Profile/DialogBox";
// import { Button, TextInput } from "flowbite-react";
// import axios from "axios";
// import { toast } from "sonner";
// import { useSelector } from "react-redux";
// import { update } from './../../../../backend/controller/uploadingVideo';

// const JobListingsTable = ({ jobs, onRowClick }) => {
//   const navigate = useNavigate();
//   const loggedinUser = useSelector((state) => state.user);
//   const { data: applicationDetails, refetch, loading: loadingApplication } = useFetchData(
//     `${APPLICATION_API}/getApplicationByJobId/${jobs?.id}`
//   );
// console.log(jobs, "jobs are coming")
//   // Calculate days left until expiration
//   const calculateDaysLeft = (expiryDate) => {
//     if (!expiryDate) return "N/A";
//     const today = new Date();
//     const expiry = new Date(expiryDate);
//     const diffTime = expiry - today;
//     const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//     return diffDays >= 0 ? `${diffDays} day${diffDays !== 1 ? 's' : ''} left` : "Expired";
//   };

//   // Boost Job State and Handler
//   const [isBoosting, setIsBoosting] = useState(false);
//   const handleBoostClick = async () => {
//     if (!loggedinUser.currentUser?.email || !jobs?.id) {
//       toast.error("User email or job not found. Please sign in again.");
//       return;
//     }
//     setIsBoosting(true);
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}job/boost-payment`,
//         {
//           jobId: jobs.id,
//           email: loggedinUser.currentUser.email,
//           amount: 5000 * 100, // 5000 NGN in kobo
//         },
//         {
//           headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//         }
//       );
//       const { authorization_url } = response.data.data;
//       // Store job ID in localStorage for post-payment verification
//       localStorage.setItem("boostedJobId", jobs.id);
//       window.location.href = authorization_url;
//     } catch (error) {
//       console.error("Error initiating payment:", error.response?.data || error.message);
//       toast.error("Failed to initiate payment. Please try again.");
//       setIsBoosting(false);
//     }
//   };
// console.log(jobs)

//   // Handle payment verification after redirect
//   useEffect(() => {
//     const verifyPayment = async () => {
//       const urlParams = new URLSearchParams(window.location.search);
//       const reference = urlParams.get('reference');
//       const boostedJobId = localStorage.getItem("boostedJobId");

//       if (reference && boostedJobId) {
//         try {
//           const response = await axios.post(
//             `${process.env.REACT_APP_API_URL}job/verify-payment`,
//             { reference, jobId: boostedJobId },
//             { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//           );
          
//           if (response.data.success) {
//             toast.success("Payment successful! Job has been boosted.");
//             localStorage.removeItem("boostedJobId");
//             // Redirect to job listings page
//             navigate("/job-listings");
//           } else {
//             toast.error("Payment verification failed.");
//           }
//         } catch (error) {
//           console.error("Payment verification error:", error.response?.data || error.message);
//           toast.error("Failed to verify payment. Please contact support.");
//         }
//       }
//     };

//     verifyPayment();
//   }, [navigate]);

//   // Edit Job State and Handler
//   const [isEditModalOpen, setIsEditModalOpen] = useState(false);
//   const [editJobData, setEditJobData] = useState({
//     title: jobs?.title || "",
//     type: jobs?.type || "",
//   });

//   useEffect(() => {
//     // Update editJobData when jobs prop changes
//     setEditJobData({
//       title: jobs?.title || "",
//       type: jobs?.type || "",
//     });
//   }, [jobs]);

//   const handleEditClick = () => {
//     setIsEditModalOpen(true);
//   };

//   const handleSaveEdit = async () => {
//     if (!jobs?.id) {
//       toast.error("No job selected to update");
//       return;
//     }
//     try {
//       await axios.put(
//         `${process.env.REACT_APP_API_URL}job/update/${jobs.id}`,
//         editJobData,
//         { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//       );
//       toast.success("Job updated successfully");
//       setIsEditModalOpen(false);
//       refetch();
//     } catch (error) {
//       console.error("Error updating job:", error.response?.data || error.message);
//       toast.error(error.response?.data?.message || "Failed to update job");
//     }
//   };

//   const handleMore = () => {
//     navigate(`/${jobs?.id}/jobApplicants`);
//   };

//   // Process application status counts
//   const statusCounts = applicationDetails?.reduce(
//     (acc, app) => {
//       acc[app.status] = (acc[app.status] || 0) + 1;
//       return acc;
//     },
//     { Applied: 0, Shortlisted: 0, Rejected: 0, Hired: 0 }
//   ) || { Applied: 0, Shortlisted: 0, Rejected: 0, Hired: 0 };

//   // Render based on loading state
//   let content = null;
//   if (loadingApplication) {
//     content = <Loader />;
//   } else {
//     content = (
//       <div className="mt-8 bg-white shadow-lg rounded-xl overflow-hidden p-6 transition-all duration-300 hover:shadow-xl">
//         {/* Header */}
//         <div className="border-b border-gray-200 pb-3">
//           <div className="flex items-center justify-between">
//             <h1 className="text-lg font-semibold text-gray-800">{jobs?.type}</h1>
//             <div className="flex items-center gap-2">
//               <span
//                 className={`${
//                   jobs?.online
//                     ? "bg-green-100 text-green-600"
//                     : "bg-red-100 text-red-600"
//                 } text-xs font-medium px-3 py-1 rounded-full`}
//               >
//                 {jobs?.online ? "online" : "offline"}
//               </span>
//               <span
//                 className={`text-xs font-medium px-2 py-1 rounded-full ${
//                   jobs?.status[0]?.value === "Online"
//                     ? "bg-green-100 text-green-600"
//                     : jobs?.status[0]?.value === "Offline"
//                     ? "bg-black text-white"
//                     : jobs?.status[0]?.value === "Awaiting Approval"
//                     ? "bg-yellow-100 text-yellow-600"
//                     : jobs?.status[0]?.value === "Draft"
//                     ? "bg-yellow-100 text-blue-600"
//                     : jobs?.status[0]?.value === "Rejected"
//                     ? "bg-red-100 text-white-600"
//                     : "bg-gray-100 text-gray-600"
//                 }`}
//               >
//                 {jobs?.status[0]?.value || "Unknown"}
//               </span>
//             </div>
//           </div>
//         </div>

//         {/* Job Title */}
//         <h1 className="mt-4 text-2xl font-bold text-orange-600">{jobs?.title}</h1>

//         {/* Job Details */}
//         <div className="flex flex-wrap items-center gap-4 mt-3">
//           <span className="bg-gray-100 text-gray-600 text-sm px-3 py-1 rounded-md">
//             {jobs?.work}
//           </span>
//           <span className="bg-gray-100 text-gray-600 text-sm px-3 py-1 rounded-md">
//             {jobs?.lga}, {jobs?.state}
//           </span>
//           <span className="text-gray-500 text-sm">
//             Expires: {jobs?.expires} ({calculateDaysLeft(jobs?.expires)})
//           </span>
//         </div>

//         {/* Application Status Counts */}
//         <div className="flex flex-wrap gap-6 py-4">
//           {Object.entries(statusCounts).map(([key, value]) => (
//             <div key={key} className="flex items-center gap-2">
//               <span className="bg-orange-500 text-white text-sm font-medium px-4 py-1 rounded-full">
//                 {value}
//               </span>
//               <span className="text-gray-600 text-sm">{key}</span>
//             </div>
//           ))}
//         </div>

//         {/* Actions */}
//         <div className="flex items-center justify-between mt-4">
//           <div className="flex gap-3">
//             <button
//               className="border-2 border-orange-500 text-orange-500 text-sm font-medium px-4 py-2 rounded-md hover:bg-orange-50 transition-colors"
//               onClick={handleEditClick}
//             >
//               Edit Job
//             </button>
//             <button
//               className="border-2 border-orange-500 text-orange-500 text-sm font-medium px-4 py-2 rounded-md hover:bg-orange-50 transition-colors"
            
//             >
//                 views: {jobs?.listedJobs?.likes}
//             </button>
//             {/* <button
//               className="border-2 border-orange-500 text-orange-500 text-sm font-medium px-4 py-2 rounded-md hover:bg-orange-50 transition-colors"
//               onClick={handleBoostClick}
//               disabled={isBoosting}
//             >
//               {isBoosting ? "Boosting..." : "Add Booster"}
//             </button> */}
//           </div>
//           <div className="flex items-center gap-4">
//             <button
//               onClick={handleMore}
//               className="flex items-center gap-1 text-gray-600 hover:text-gray-800 transition-colors"
//             >
//               <CgMoreVertical className="text-md" size={20} />
//               <span className="text-sm">More</span>
//             </button>
//             <button
//               onClick={() => onRowClick(jobs?.id)}
//               className="flex items-center gap-1 text-gray-600 hover:text-gray-800 transition-colors"
//             >
//               <BsEye className="text-md" size={20} />
//               <span className="text-sm">View</span>
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   // Edit Modal
//   const handleCloseEditModal = () => setIsEditModalOpen(false);

//   return (
//     <>
//       {content}
//       <Dialog
//         open={isEditModalOpen}
//         onClose={handleCloseEditModal}
//         title="Edit Job"
//         size="2xl"
//       >
//         <div className="space-y-4">
//           <TextInput
//             value={editJobData.title}
//             onChange={(e) => setEditJobData({ ...editJobData, title: e.target.value })}
//             placeholder="Job Title"
//             required
//           />
//           <TextInput
//             value={editJobData.type}
//             onChange={(e) => setEditJobData({ ...editJobData, type: e.target.value })}
//             placeholder="Job Type"
//             required
//           />
//         </div>
//         <div className="flex justify-end gap-2 mt-4">
//           <Button color="blue" onClick={handleSaveEdit}>
//             Save Changes
//           </Button>
//           <Button color="gray" onClick={handleCloseEditModal}>
//             Cancel
//           </Button>
//         </div>
//       </Dialog>
//     </>
//   );
// };

// export default JobListingsTable;




import React, { useState, useEffect } from "react";
import { BsEye } from "react-icons/bs";
import { CgMoreVertical } from "react-icons/cg";
import { Link, useNavigate } from "react-router-dom";
import { APPLICATION_API } from "../../resources/resource";
import { useFetchData } from "../../hooks/useFtechData";

import Loader from "../../component/utilities/Loader";
import { Dialog } from "../Profile/DialogBox";
import { Button, TextInput, Label } from "flowbite-react";
import axios from "axios";
import { toast } from "sonner";
import { useSelector } from "react-redux";

const JobListingsTable = ({ jobs, onRowClick }) => {
  const navigate = useNavigate();
  const loggedinUser = useSelector((state) => state.user);

  const { data: applicationDetails, refetch, loading: loadingApplication } = useFetchData(
    `${APPLICATION_API}/getApplicationByJobId/${jobs?.id}`
  );

  // Calculate days left
  const calculateDaysLeft = (expiryDate) => {
    if (!expiryDate) return "N/A";
    const today = new Date();
    const expiry = new Date(expiryDate);
    const diffTime = expiry - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays >= 0 ? `${diffDays} day${diffDays !== 1 ? "s" : ""} left` : "Expired";
  };

  // Boost Job (unchanged)
  const [isBoosting, setIsBoosting] = useState(false);
  const handleBoostClick = async () => {
    // ... your existing boost logic
  };

  // Edit & Delete Modal State
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const [editJobData, setEditJobData] = useState({
    title: "",
    type: "",
    // Add more fields here as needed, e.g.:
    // work: "", description: "", state: "", lga: "", expires: "", etc.
  });

  // Sync edit data when jobs prop changes
  useEffect(() => {
    if (jobs) {
      setEditJobData({
        title: jobs.title || "",
        type: jobs.type || "",
        // Add other fields here, e.g.:
        // work: jobs.work || "",
        // expires: jobs.expires || "",
      });
    }
  }, [jobs]);

  const handleEditClick = () => {
    setIsEditModalOpen(true);
  };

  const handleCloseEditModal = () => {
    setIsEditModalOpen(false);
  };

  // Save Updated Job
  const handleSaveEdit = async () => {
    if (!jobs?.id) {
      toast.error("No job selected to update");
      return;
    }

    setIsSaving(true);
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}job/update/${jobs.id}`,
        editJobData,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      toast.success("Job updated successfully!");
      setIsEditModalOpen(false);
      refetch(); // Refresh application data or parent list if needed
    } catch (error) {
      console.error("Update error:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Failed to update job");
    } finally {
      setIsSaving(false);
    }
  };

  // Delete Job
  const handleDeleteJob = async () => {
    if (!jobs?.id) return;

    if (!window.confirm("Are you sure you want to delete this job? This action cannot be undone.")) {
      return;
    }

    setIsDeleting(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_API_URL}job/jobs/${jobs.id}`,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );

      toast.success("Job deleted successfully!");
      setIsEditModalOpen(false);

      // Optional: Notify parent component to remove this job from the list
      // You can add a prop like `onJobDeleted(jobs.id)` and call it here
      // onJobDeleted?.(jobs.id);

      refetch();
    } catch (error) {
      console.error("Delete error:", error.response?.data || error.message);
      toast.error(error.response?.data?.message || "Failed to delete job");
    } finally {
      setIsDeleting(false);
    }
  };

  const handleMore = () => {
    navigate(`/${jobs?.id}/jobApplicants`);
  };

  // Application status counts
  const statusCounts = applicationDetails?.reduce(
    (acc, app) => {
      acc[app.status] = (acc[app.status] || 0) + 1;
      return acc;
    },
    { Applied: 0, Shortlisted: 0, Rejected: 0, Hired: 0 }
  ) || { Applied: 0, Shortlisted: 0, Rejected: 0, Hired: 0 };

  let content = null;
  if (loadingApplication) {
    content = <Loader />;
  } else {
    content = (
      <div className="mt-8 bg-white shadow-lg rounded-xl overflow-hidden p-6 transition-all duration-300 hover:shadow-xl">
        {/* Header */}
        <div className="border-b border-gray-200 pb-3">
          <div className="flex items-center justify-between">
            <h1 className="text-lg font-semibold text-gray-800">{jobs?.type}</h1>
            <div className="flex items-center gap-2">

              <span className="bg-green-100 text-green-600 px-2">
                      <Link to='/employer/:id?tab=staffAssessment'>
                      assessment

                      </Link>
              </span>
              <span
                className={`${
                  jobs?.online ? "bg-green-100 text-green-600" : "bg-red-100 text-red-600"
                } text-xs font-medium px-3 py-1 rounded-full`}
              >
                {jobs?.online ? "online" : "offline"}
              </span>
              <span
                className={`text-xs font-medium px-2 py-1 rounded-full ${
                  jobs?.status?.[0]?.value === "Online"
                    ? "bg-green-100 text-green-600"
                    : jobs?.status?.[0]?.value === "Offline"
                    ? "bg-black text-white"
                    : jobs?.status?.[0]?.value === "Awaiting Approval"
                    ? "bg-yellow-100 text-yellow-600"
                    : jobs?.status?.[0]?.value === "Draft"
                    ? "bg-yellow-100 text-blue-600"
                    : jobs?.status?.[0]?.value === "Rejected"
                    ? "bg-red-100 text-red-600"
                    : "bg-gray-100 text-gray-600"
                }`}
              >
                {jobs?.status?.[0]?.value || "Unknown"}
              </span>
            </div>
          </div>
        </div>

        <h1 className="mt-4 text-2xl font-bold text-orange-600">{jobs?.title}</h1>

        <div className="flex flex-wrap items-center gap-4 mt-3">
          <span className="bg-gray-100 text-gray-600 text-sm px-3 py-1 rounded-md">
            {jobs?.work}
          </span>
          <span className="bg-gray-100 text-gray-600 text-sm px-3 py-1 rounded-md">
            {jobs?.lga}, {jobs?.state}
          </span>
          <span className="text-gray-500 text-sm">
            Expires: {jobs?.expires} ({calculateDaysLeft(jobs?.expires)})
          </span>
        </div>

        <div className="flex flex-wrap gap-6 py-4">
          {Object.entries(statusCounts).map(([key, value]) => (
            <div key={key} className="flex items-center gap-2">
              <span className="bg-orange-500 text-white text-sm font-medium px-4 py-1 rounded-full">
                {value}
              </span>
              <span className="text-gray-600 text-sm">{key}</span>
            </div>
          ))}
        </div>

        {/* Actions */}
        <div className="flex items-center justify-between mt-4">
          <div className="flex gap-3">
            <button
              className="border-2 border-orange-500 text-orange-500 text-sm font-medium px-4 py-2 rounded-md hover:bg-orange-50 transition-colors"
              onClick={handleEditClick}
            >
              Edit Job
            </button>

            <button
              className="border-2 border-orange-500 text-orange-500 text-sm font-medium px-4 py-2 rounded-md hover:bg-orange-50 transition-colors"
            >
              views: {jobs?.listedJobs?.likes || 0}
            </button>
          </div>

          <div className="flex items-center gap-4">
            <button
              onClick={handleMore}
              className="flex items-center gap-1 text-gray-600 hover:text-gray-800 transition-colors"
            >
              <CgMoreVertical size={20} />
              <span className="text-sm">More</span>
            </button>
            <button
              onClick={() => onRowClick(jobs?.id)}
              className="flex items-center gap-1 text-gray-600 hover:text-gray-800 transition-colors"
            >
              <BsEye size={20} />
              <span className="text-sm">View</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {content}

      {/* Edit + Delete Modal */}
      <Dialog
        open={isEditModalOpen}
        onClose={handleCloseEditModal}
        title="Edit Job"
        size="2xl"
      >
        <div className="space-y-4">
          <div>
            <Label htmlFor="title" value="Job Title" />
            <TextInput
              id="title"
              value={editJobData.title}
              onChange={(e) =>
                setEditJobData({ ...editJobData, title: e.target.value })
              }
              placeholder="Job Title"
              required
            />
          </div>

          <div>
            <Label htmlFor="type" value="Job Type" />
            <TextInput
              id="type"
              value={editJobData.type}
              onChange={(e) =>
                setEditJobData({ ...editJobData, type: e.target.value })
              }
              placeholder="Job Type (e.g. Full-time, Remote)"
              required
            />
          </div>

          {/* Add more fields here as needed */}
        </div>

        <div className="flex justify-between gap-3 mt-6">
          {/* Delete Button - Danger style */}
          <Button
            color="failure"
            onClick={handleDeleteJob}
            disabled={isDeleting}
            isProcessing={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete Job"}
          </Button>

          {/* Action Buttons */}
          <div className="flex gap-2">
            <Button color="gray" onClick={handleCloseEditModal}>
              Cancel
            </Button>
            <Button
              color="blue"
              onClick={handleSaveEdit}
              disabled={isSaving}
              isProcessing={isSaving}
            >
              {isSaving ? "Saving..." : "Save Changes"}
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default JobListingsTable;